import React from 'react';
import { Fab, Tooltip, Zoom, Badge } from '@mui/material';
import { Chat as ChatIcon } from '@mui/icons-material';
import { useActiveChats } from '../contexts/ActiveChatsContext';

const FloatingChatButton = () => {
  const { unreadCount, toggleCompactChat } = useActiveChats();

  const handleClick = () => {
    if (Number(unreadCount || 0) > 0) {
      window.location.href = '/integrated-whatsapp-chat';
      return;
    }
    toggleCompactChat();
  };

  return (
    <Zoom in={true}>
      <Tooltip title="Abrir Chat" placement="left">
        <Fab
          color="primary"
          onClick={handleClick}
          sx={{
            position: 'fixed',
            bottom: 16,
            right: 16,
            zIndex: 1000
          }}
        >
          <Badge badgeContent={unreadCount} color="error">
            <ChatIcon />
          </Badge>
        </Fab>
      </Tooltip>
    </Zoom>
  );
};

export default FloatingChatButton;
